
import { AuthProvider } from './contexts/AuthContext';
import AppContent from './AppContent';
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    const requestNotificationPermission = async () => {
      if ('Notification' in window) {
        try {
          const permission = await Notification.requestPermission();
          console.log('Notification permission:', permission);
        } catch (error) {
          console.error('Error requesting notification permission:', error);
        }
      }
    };

    requestNotificationPermission();
  }, []);


  return (
    <AuthProvider>
        <AppContent />
    </AuthProvider>
  );
}

export default App;